import { render } from "./ProductCardHelper.vue?vue&type=template&id=0ae3412a"
import script from "./ProductCardHelper.vue?vue&type=script&lang=js"
export * from "./ProductCardHelper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__